import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { PACKAGE_CALENDAR_PRICES } from '~/endpoints';
import { PackageCalendarRequestSchema, PackageCalendarResponseSchema } from '~/validation/api/packageCalendarResponse';
import { handleErrorResponse } from '~/helpers/api';
import { PackageCalendarRequest } from '~/types/api';

export const getCalendarData = async (data: PackageCalendarRequest) => {
  const body = PackageCalendarRequestSchema.parse(data);

  const api = PACKAGE_CALENDAR_PRICES.replace(':packageId', body.package_id.toString());

  try {
    const response = await axios.post(api, data);

    const json = response.data;

    return PackageCalendarResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function useCalendarData(obj: PackageCalendarRequest) {
  return useQuery({
    queryKey: ['calendarData', obj.start_date, obj.end_date, obj.pax, obj.package_id],
    queryFn: () => getCalendarData(obj),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
